import styled, {css} from 'styled-components'

export const StyledActions = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 4}px;
    `}
`
